<template>
  <div
    v-if="stepIndex < steps.length"
    class="step-indicator"
  >
    <ul class="step-indicator__list">
      <li
        v-for="(step, index) in steps"
        :key="index"
        class="step-indicator__item"
      >
        <span
          v-t="step"
          v-if="index > stepIndex || stepIndex >= steps.length"
        />
        <a
          v-t="step"
          v-else
          :class="{'step-indicator__link--active' : stepIndex === index}"
          class="step-indicator__link"
          href="#"
          @click.prevent="gotoStep(index)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    stepIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      steps: [
        'c.mailingOverlay.stepHistory.title',
        'c.mailingOverlay.stepTitle.title',
        'c.mailingOverlay.stepTags.title',
        'c.mailingOverlay.stepArticles.title',
        'c.mailingOverlay.stepRecipients.title',
        'c.mailingOverlay.stepSummary.title'
      ]
    }
  },
  methods: {
    gotoStep (index) {
      this.$emit('gotoStep', index)
    }
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.step-indicator
  align-self: center;

  &__list

  &__item
    +font-size(14, 18)
    display: inline-block
    float: left
    color: #878C96

    & + &
      &:before
        display: inline-block;
        content: '>'
        margin: 0 10px
        color: #878C96
  &__link
    color: #878C96

    &:hover,
    &:focus
      text-decoration: none

    &--active
      color: var(--mainColor)
</style>



// WEBPACK FOOTER //
// src/components/mailings/MailingOverlayStepIndicator.vue